// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["modules_Core_scripts_utilities_js-modules_Widgets_NewsletterSlideIn_index_js-modules_Core_scs-d1632a","modules_Core_scss__shortlist_scss","modules_Core_scripts_sitewide_js"], function() { return __webpack_require__("./modules/HeroArticle/index.js"); })
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
